import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiCircle, FiRocket, FiTrendingUp, FiStar, FiGlobe } = FiIcons;

const Roadmap = () => {
  const roadmapItems = [
    {
      phase: 'Phase 1',
      title: 'Launch & Foundation',
      status: 'completed',
      items: [
        'Token Launch on Pump.fun',
        'Community Building',
        'Social Media Presence',
        'Initial Marketing Push'
      ]
    },
    {
      phase: 'Phase 2',
      title: 'Growth & Expansion',
      status: 'current',
      items: [
        'Major Exchange Listings',
        'Partnership Announcements',
        'Influencer Collaborations',
        'Community Rewards Program'
      ]
    },
    {
      phase: 'Phase 3',
      title: 'Utility & Innovation',
      status: 'upcoming',
      items: [
        'PinkZilla NFT Collection',
        'Staking Platform Launch',
        'Mobile App Development',
        'Gaming Integration'
      ]
    },
    {
      phase: 'Phase 4',
      title: 'Global Domination',
      status: 'upcoming',
      items: [
        'Multi-chain Expansion',
        'Major Brand Partnerships',
        'PinkZilla Ecosystem',
        'World Tour Events'
      ]
    }
  ];

  return (
    <section id="roadmap" className="py-20 px-4">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Our <span className="bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent">Roadmap</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From launch to global domination - here's how we're building the future of meme coins.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {roadmapItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="relative mb-12"
            >
              {/* Timeline Line */}
              {index < roadmapItems.length - 1 && (
                <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-24 bg-gradient-to-b from-pink-300 to-purple-300 mt-20 z-0" />
              )}

              <div className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className="flex-1 p-6">
                  <div className={`bg-white rounded-2xl p-8 shadow-lg ${index % 2 === 0 ? 'mr-8' : 'ml-8'}`}>
                    <div className="flex items-center space-x-3 mb-4">
                      <span className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                        {item.phase}
                      </span>
                      <div className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        item.status === 'completed' ? 'bg-green-100 text-green-700' :
                        item.status === 'current' ? 'bg-yellow-100 text-yellow-700' :
                        'bg-gray-100 text-gray-700'
                      }`}>
                        {item.status === 'completed' ? 'Completed' :
                         item.status === 'current' ? 'In Progress' : 'Upcoming'}
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">{item.title}</h3>
                    <ul className="space-y-2">
                      {item.items.map((subItem, subIndex) => (
                        <li key={subIndex} className="flex items-center space-x-2">
                          <SafeIcon 
                            icon={item.status === 'completed' ? FiCheckCircle : FiCircle}
                            className={`${item.status === 'completed' ? 'text-green-500' : 'text-gray-400'}`}
                          />
                          <span className="text-gray-700">{subItem}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Timeline Node */}
                <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center z-10">
                  <SafeIcon 
                    icon={item.status === 'completed' ? FiCheckCircle : 
                          item.status === 'current' ? FiRocket : FiStar}
                    className="text-white text-xl"
                  />
                </div>

                <div className="flex-1 p-6">
                  {/* Empty space for alternating layout */}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mt-16 text-center"
        >
          <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-3xl p-8 text-white max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">Be Part of the Journey</h3>
            <p className="text-lg mb-6 opacity-90">
              Join us as we execute our roadmap and build the most successful meme coin in history!
            </p>
            <motion.a
              href="https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-pink-600 px-8 py-3 rounded-full font-bold text-lg inline-flex items-center space-x-2 hover:bg-pink-50 transition-all"
            >
              <SafeIcon icon={FiRocket} />
              <span>Get $PINKZILLA Now</span>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Roadmap;